import React from 'react';
import {BaseWorkflow} from "./BaseWorkflow";

export class Seller2POnboardFlow extends BaseWorkflow {

    paintVertexBasedOnStatus(vertex, nodeMap) {
        const node = nodeMap.get(vertex.id);
        if (node === undefined) {
            return;
        }

        // Regular color scheme
        this.defineRegularStatusColor(node, vertex)
    }

    generateGraphElements(nodeList) {
        const nodeMap = new Map();
        nodeList.forEach(node => {
            nodeMap.set(node.id, node);
        });
        const vertices = [
            {id: 'SellerInfoUpload', data: {label: '信息上传'}, position: this.generateCenterPosition({x: 0, y: 0})},
            {id: 'McoStep1Review', data: {label: 'OPS审核'}, position: this.generateCenterPosition({x: 0, y: 150})},
            {id: 'McoStep2Review', data: {label: '执行入库'}, position: this.generateCenterPosition({x: 0, y: 300})},
        ];
        vertices.forEach(vertex => {
            this.paintVertexBasedOnStatus(vertex, nodeMap);
        });
        const edges = [
            {id: 'e-SellerInfoUpload-McoStep1Review', source: 'SellerInfoUpload', target: 'McoStep1Review', type: 'smoothstep'},
            {id: 'e-McoStep1Review-McoStep2Review', source: 'McoStep1Review', target: 'McoStep2Review', type: 'smoothstep'},
        ];
        return [...vertices, ...edges];
    }
}